import type { BelegReviewState } from "../api/belege";

export type ReviewStatus = "open" | "in_review" | "resolved";

export const REVIEW_STATUS_LABELS: Record<ReviewStatus, string> = {
  open: "Prüfung erforderlich",
  in_review: "In Bearbeitung",
  resolved: "Abgeschlossen",
};

export const REVIEW_STATE_LABELS: Record<BelegReviewState, string> = {
  open: "Prüfung erforderlich",
  complaint: "Klärung angefragt",
  credit_expected: "Gutschrift erwartet",
  write_off: "Ausgebucht",
  credit_resolved: "Gutschrift erhalten",
};

export function reviewStatusLabel(status: ReviewStatus): string {
  return REVIEW_STATUS_LABELS[status];
}

export function reviewStateLabel(state: BelegReviewState): string {
  return REVIEW_STATE_LABELS[state];
}
